// Use native inputs on small screens as well as apple devices
export const useNativeInputs = () =>
  window.innerWidth < 768 || /iPad|iPhone|iPod/.test(navigator.userAgent);
